import "../../css/DialogWindow.css";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import DialogHeader from "./dialogHeader";

export default class DialogWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {visible: false};
  }

  toggleVisibility(){
    this.setState({visible: !this.state.visible});
  }

  close(){
    this.setState({visible: false});
  }

  render() {
    if (!this.state.visible) {
      return <></>;
    }

    return ReactDOM.createPortal(
      <div className="dialogbackground">
        <div className={`dialogwindow${this.props.className ? ` ${this.props.className}` : ''}`}>
          <DialogHeader
            onAdd={this.props.onAdd} onBack={this.props.onBack} onClose={this.close.bind(this)}
            title={this.props.title}
          />
          {this.props.children}
        </div>
      </div>,
      document.body
    );
  }
}
